import React, {useState} from 'react'
import {Input, Button, FieldProps, mergeClasses} from "@fluentui/react-components";
import AlertDialog from './AlertDialog'
import {
    ShoppingParticipationDataTransferObject
} from "../../../../../model/dto/content/ShoppingParticipationDataTransferObject";
import {StatePair, useStatePair} from "../../../../../type/States";
import {DataTransferObjectValidation} from "../../../../../type/Types";
import {ShoppingParticipationIO} from "../../../../../io/content/shoppingParticipationIO";
import {greenTheme} from "../../../../../styles/mission/theme";
import {useAnswerInputStyles, useStyles} from "../../../../../styles/mission/ver1";
import {getFormattedDate} from "../../../../../utils/formatDate";
import {isVisible} from "../../../../../utils/bitmask";
import {ArrowEnterFilled, CopyRegular} from "@fluentui/react-icons";
import {copyToClipboard, onHandleUrlBtn} from "../../../../../utils/nshopQuiz";
import {EventType} from "../../../../../constant/EventType";
import {ShoppingPresentationValueObject} from "../../../../../model/vo/content/ShoppingPresentationValueObject";
import {Column, Row} from "../../../common/Layout";

import {
    useCurrentPageUpdate,
    useGuideExpirationDate, useHiddenGuideListUpdate,
    useNextPageUpdate, useSetIsFinish
} from "../../../../../stores/useStore";
import {useNavigate} from "react-router-dom";
import {ShoppingPathJointEventIO} from "../../../../../io/content/shoppingPathJointEventIO";
import {useUserStore} from "../../../../../stores/useUserStore";
import {CampaignCodeValues} from "../../../../../constant/mediaCode";
import {useQuery} from "../../../../../hooks/useQuery";
import {PathTypePlaceHolderString} from "../../../../../constant/pathType";
import {setPathType} from "../../../../../utils/pathType";

export default function AnswerInput({
                                        shoppingPathJointId,
                                        userId,
                                        mediaId,
                                        mediaCode,
                                        data,
                                        primaryColor
                                    }: {
    shoppingPathJointId: bigint
    userId: bigint
    mediaId: string
    mediaCode: string
    data: ShoppingPresentationValueObject
    primaryColor: string
}) {
    const styles = useAnswerInputStyles()
    const basicStyles = useStyles()

    const [answer, setAnswer] = useState('')
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
    const [dialogMsg, setDialogMsg] = useState<string>('정답 제출 중 입니다...')
    const [dialogTitle, setDialogTitle] = useState<string>('로딩중')
    const [isCopied, setIsCopied] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()
    const query = useQuery()

    const setIsFinish = useSetIsFinish()

    const hideGuide = useGuideExpirationDate()

    const updateCurrentPage = useCurrentPageUpdate()
    const updateNextPage = useNextPageUpdate()
    const updateHiddenGuideList = useHiddenGuideListUpdate()

    const userInfo = useUserStore();

    const inputValidationStates: Record<keyof ShoppingParticipationDataTransferObject.PostBack, StatePair<FieldProps['validationState']>> = {
        shoppingPathJointId: useStatePair<FieldProps['validationState']>('none'),
        userId: useStatePair<FieldProps['validationState']>('none'),
        answer: useStatePair<FieldProps['validationState']>('none'),
        mediaId: useStatePair<FieldProps['validationState']>('none'),
        mediaCode: useStatePair<FieldProps['validationState']>('none'),
    }

    const openDialog = (title: string, content: string) => {
        try {
            setDialogTitle(title)
            setDialogMsg(content)
        } finally {
            setIsDialogOpen(true)
        }
    }

    const closeDialog = () => setIsDialogOpen(false)

    const submitAnswer = async (answer: string) => {

        inputValidationStates.shoppingPathJointId.setValue('none')
        inputValidationStates.userId.setValue('none')
        inputValidationStates.answer.setValue('none')
        inputValidationStates.mediaId.setValue('none')
        inputValidationStates.mediaCode.setValue('none')

        try {

            if (shoppingPathJointId && userId && mediaId) {
                ShoppingPathJointEventIO.post({
                    shoppingPathJointId: data.shoppingPathJointId,
                    userId: data.userId,
                    misc: mediaId,
                    eventType: EventType.ShoppingAnswerSubmitClick
                }).then(
                    v => console.log(v)
                ).catch(e => console.error(e))
            }

            const dto = {
                shoppingPathJointId: DataTransferObjectValidation.validate(ShoppingParticipationDataTransferObject.PostBack.validation, 'shoppingPathJointId', shoppingPathJointId.toString(), () => inputValidationStates.shoppingPathJointId.setValue('error')),
                userId: DataTransferObjectValidation.validate(ShoppingParticipationDataTransferObject.PostBack.validation, 'userId', userId.toString(), () => inputValidationStates.userId.setValue('error')),
                answer: DataTransferObjectValidation.validate(ShoppingParticipationDataTransferObject.PostBack.validation, 'answer', answer, () => inputValidationStates.answer.setValue('error')),
                mediaId: DataTransferObjectValidation.validate(ShoppingParticipationDataTransferObject.PostBack.validation, 'mediaId', mediaId, () => inputValidationStates.mediaId.setValue('error')),
                mediaCode: DataTransferObjectValidation.validate(ShoppingParticipationDataTransferObject.PostBack.validation, 'mediaCode', mediaCode, () => inputValidationStates.mediaCode.setValue('error')),
                campaignCode: query.get("campaignCode") as CampaignCodeValues
            }

            ShoppingParticipationIO.post(dto)
                .then((res: any)=>{

                    if (!res) {
                        navigate('/error')
                        setCurrentPage()
                        return
                    }

                    if (res.isPassed && res.isPostBackSuccess) {
                        navigate('/success')
                        setIsFinish(true)
                        setCurrentPage()
                        // openDialog(
                        //     '미션 성공!',
                        //     `정답입니다!\n미션에 참가해주셔서 감사하겠습니다.`
                        // )
                        // setTimeout(() => {
                        //     closeDialog()
                        // }, 2000)
                    } else if (res.isPassed && !res.isPostBackSuccess) {
                        navigate('/failure')
                        setIsFinish(true)
                        setCurrentPage()
                        // openDialog(
                        //     '적립실패',
                        //     `미션에 참여해주셔서 감사합니다!\n미션 적립에 실패했습니다.\n다른 미션에 참가해주시면 감사하겠습니다.`,
                        // )
                        // setTimeout(() => {
                        //     closeDialog()
                        // }, 2000)
                    } else {
                        openDialog('오답', '정답이 틀렸습니다.')
                        setTimeout(() => {
                            closeDialog()
                        }, 3000)
                    }
                })
                .catch((e)=>{
                    console.error(e)
                    openDialog('오답', '정답 제출 중에 오류가 발생했습니다.')
                })

        } catch (error) {
            console.error(error)
            openDialog('오류', '정답 제출 중에 오류가 발생했습니다.')
            navigate('/error')
        }
    }

    const setCurrentPage = () => {
        if (!hideGuide || getFormattedDate(new Date(hideGuide)).getTime() < getFormattedDate(new Date()).getTime()) {
            updateCurrentPage('GuideLine');
            updateNextPage('Mission');
        } else {
            updateCurrentPage('Mission');
            updateNextPage('Mission');
        }
    }

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!answer) {
            alert('정답을 입력해주세요')
            return
        }
        setIsLoading(true)
        try {
            openDialog('로딩중', '정답 제출 중 입니다.....')
            await submitAnswer(answer)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className={styles.main} style={{backgroundColor:greenTheme.bgColor100}}>
                <AlertDialog
                    title={dialogTitle}
                    description={dialogMsg}
                    isOpen={isDialogOpen}
                    onClose={closeDialog}
                />
                <Column gap={'8px'}>
                <Row gap={'8px'}>
                {/* Buttons */}
                {isVisible(data.visibility, 6) && (
                    <Button
                        icon={<CopyRegular/>}
                        className={mergeClasses(basicStyles.roundedBtn, basicStyles.outlinedBtn)}
                        style={{flex:1}}
                        size="large"
                        onClick={() => {
                            copyToClipboard(
                                data.mainKeyword || '',
                                () => {
                                    openDialog("오류", "복사에 실패했습니다.");
                                    setTimeout(() => {
                                        closeDialog();
                                    }, 10000);
                                    return;
                                },
                                () => {
                                    setIsCopied(true)
                                    if (data.shoppingPathJointId && data.userId && userInfo.misc) {
                                        ShoppingPathJointEventIO.post({
                                            shoppingPathJointId: data.shoppingPathJointId,
                                            userId: data.userId,
                                            misc: userInfo.misc,
                                            eventType: EventType.ClipboardClick
                                        }).then(
                                            v => console.log(v)
                                        ).catch(e => console.error(e))
                                    }
                                },
                                () => {
                                }
                            );
                        }}
                    >
                        검색어 복사하기
                    </Button>
                )}

                {isVisible(data.visibility, 7) && (
                    <Button
                        icon={<ArrowEnterFilled/>}
                        className={basicStyles.roundedBtn}
                        style={{
                            backgroundColor: primaryColor,
                            color: 'white',
                            border: `1.5px solid ${primaryColor}`,
                            flex: 1
                        }}
                        onClick={() =>
                            onHandleUrlBtn(
                                data.format || '',
                                isVisible(data.visibility, 6),
                                data.browser || '',
                                isCopied,
                                () => {
                                    openDialog('경고', '복사가 필요한 미션입니다!');
                                    setTimeout(() => {
                                        closeDialog();
                                    }, 10000);
                                    return;
                                },
                                () => {
                                    if (data.shoppingPathJointId && data.userId && userInfo.misc) {
                                        ShoppingPathJointEventIO.post({
                                            shoppingPathJointId: data.shoppingPathJointId,
                                            userId: data.userId,
                                            misc: userInfo.misc,
                                            eventType: EventType.MissionClick
                                        }).then(
                                            v => {
                                                console.log(v)
                                            }
                                        ).catch(e => console.error(e))
                                    }
                                }
                            )
                        }
                    >
                        미션하러 가기
                    </Button>
                )}
                </Row>
                <form onSubmit={onSubmit} className={styles.form} style={{backgroundColor: primaryColor}}>
                    <Input
                        placeholder={PathTypePlaceHolderString[setPathType(data.pathType)]}
                        value={answer}
                        className={styles.input}
                        style={{flex:3}}
                        onChange={(e, data) => setAnswer(data.value)}
                        required
                    />
                    <Button
                        type="submit"
                        className={styles.roundBtn}
                        style={{flex:1,backgroundColor: 'black', color:'white'}}
                        disabled={isLoading}
                    >
                        제출하기
                    </Button>
                </form>
                </Column>

        </div>
    )
}